"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.formatTransaction = exports.toTransactionRaw = exports.fromTransactionRaw = void 0;
__exportStar(require("./common"), exports);
__exportStar(require("./status"), exports);
__exportStar(require("./signOperation"), exports);
__exportStar(require("./deviceTransactionConfig"), exports);
var transaction_1 = __importDefault(require("../generated/transaction"));
var fromTransactionRaw = function (tr) {
    var TM = transaction_1["default"][tr.family];
    // FIXME: something is wrong with TM.fromTransactionRaw expecting a (arg: never) => for some reasons
    return TM.fromTransactionRaw(tr);
};
exports.fromTransactionRaw = fromTransactionRaw;
var toTransactionRaw = function (t) {
    var TM = transaction_1["default"][t.family];
    // FIXME: something is wrong with TM.toTransactionRaw expecting a (arg: never) => for some reasons
    return TM.toTransactionRaw(t);
};
exports.toTransactionRaw = toTransactionRaw;
var formatTransaction = function (t, a) {
    var TM = transaction_1["default"][t.family];
    // FIXME: something is wrong with TM.formatTransaction expecting a (arg: never) => for some reasons
    return TM.formatTransaction ? TM.formatTransaction(t, a) : "";
};
exports.formatTransaction = formatTransaction;
//# sourceMappingURL=index.js.map